import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { buildPortalUrlForKey, resolvePortalHomeUrl } from './portal-redirect.util';

/**
 * يمنع مستخدمي البوابات الخارجية (مريض/طبيب/مختبر إحالة) من رؤية أي صفحة في
 * البوابة المركزية ويحوّلهم دائماً إلى تطبيقهم. القرار معتمد على الخادم
 * (`/api/account/portal-target`) المبني على رتبة المستخدم/ارتباطه في قاعدة
 * البيانات — لا على سكوبات التوكن (التي قد تتأثر بصلاحيات قراءة عابرة). يُركَّب
 * على مسار اللاي-آوت بعد AuthGuard، فلا يعمل إلا والمستخدم مصادَق. صفحة الدخول
 * خارج هذا المسار فتبقى الوحيدة المرئية لهم.
 */

// تخزين بسيط لكل توكن: قرار البوابة لا يتغيّر خلال الجلسة، فنتجنّب طلباً لكل تنقّل.
let cachedForToken: string | null = null;
let cachedPortalKey: string | null = null;

export const PortalRedirectGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const http = inject(HttpClient);
  const token = auth.accessToken;

  let serverDecided = false;
  let portalKey: string | null = null;

  if (token && token === cachedForToken) {
    portalKey = cachedPortalKey;
    serverDecided = true;
  } else {
    try {
      const resp = await firstValueFrom(
        http.get<{ portalKey?: string | null }>(`${environment.apiBase}/api/account/portal-target`)
      );
      portalKey = resp?.portalKey ?? null;
      cachedForToken = token;
      cachedPortalKey = portalKey;
      serverDecided = true;
    } catch {
      serverDecided = false; // فشل الاتصال — نلجأ لاستنتاج التوكن أدناه.
    }
  }

  const url = serverDecided
    ? buildPortalUrlForKey(portalKey, token)
    : resolvePortalHomeUrl(auth.claims, token);

  if (url) {
    window.location.href = url;
    return false;
  }
  return true;
};
